import config from 'crm/config'

const taskApi = `${config.apiHost}/oem-task-system`

export default {
    detail: {
        url: `${taskApi}/api/tasks/{id}`,
        type: 'GET',
    },
    create: {
        url: `${taskApi}/api/tasks`,
        type: 'POST',
    },
    update: {
        url: `${taskApi}/api/tasks/{id}`,
        type: 'PUT',
    },
}
